export default {
  updateCategory (state, category) {
    for (let i = 0; i < state.categories.length; i++) {
      if (state.categories[i].group === category.group) {
        state.categories[i] = category
      }
    }
  }
}
